module.exports = __webpack_public_path__ + "static/media/gold-badge.3c80f9d5.svg";